import {PHIEU_IN_ENDPOINT, WF_TRACKER} from "../../../../utils/Constant";
import { TypeKeHoach } from "../models/KeHoachModel";

export const WMS_STATUS = {
  build_plan: "build_plan",
  directDownline: "directDownline",
  build_plan_approved: "build_plan_approved",
};

export const CODE_NHAP_KHO = {
  NHA_CUNG_CAP: 'X004',
  TRA_LE: 'X003',
  KHAC: 'X005',
  HOAN_TRA: 'X011',
}

export const TYPE_KE_HOACH: TypeKeHoach[] = [
  {
    name: 'Hội chẩn kcb từ xa',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formThongTinChung: 'dohahoichankcb',
    formVatTu: '',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.BUILD_PLAN_CONSULTATION,
    termModelType: "directDownline"
  }
];

export const TYPE_KB_CB = {
  NHAN_LUC :
    {
      name: 'Nhân lực',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohanhanluc',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN,
      termModelType: "directDownline"
    },
  QUA_TRINH_CHUYEN_GIAO :
    {
      name: 'Nhân lực',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohanhanlucquatrinhchuyengiao',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN,
      termModelType: "directDownline"
    },
  BIEN_BAN_HOI_CHAN :
    {
      name: 'Lập biên bản hội chẩn',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohabienbanhoichan',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN_CONSULTATION,
      termModelType: "directDownline"
    },
  CA_BENH:
    {
      name: 'Theo dõi ca bệnh',
      code: 'dohatheodoicabenh',
      formThongTinChung: 'dohatheodoicabenh',
      formVatTu: 'dohatheodoicabenh',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: WF_TRACKER.BUILD_PLAN_CONSULTATION,
      termModelType: ''
    },
  LICH_HOI_CHAN :
    {
      name: 'Nghiệm thu',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohalichhoichan',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN,
      termModelType: "directDownline"
    },
}

export const STATUS_CODE = {
  'new_save': 'new_save',
  'approved': 'approved',
  'being_consultation': 'being_consultation',
  'case_monitoring': 'case_monitoring',
}